import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { GlobalServices } from 'app/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'training-list',
    templateUrl: './training-list.component.html',
    styleUrls: ['./training-list.component.scss'],
    providers: [DialogService]
})
export class TrainingListComponent implements OnInit {
    activeTab: 'calendar' | 'history' = 'calendar';

    public IsBusy: boolean = false;

    constructor(
        private router: Router,
        private _Activatedroute: ActivatedRoute,
        private _fb: UntypedFormBuilder,
		public gb : GlobalServices
		) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this._Activatedroute.queryParams.subscribe((param) => {
          this.activeTab = param.activeTab || 'calendar';
        });
    }

    activeTabChange(viewType) {
        this.activeTab = viewType;
    }
}
